import axios from 'axios'

export const seq = axios.create({
  baseURL: import.meta.env.APP_SEQ_URL,
  headers: { 'Content-Type': 'application/vnd.serilog.clef' }
})
